module.exports = __webpack_public_path__ + "img/union_europea.2f82790c.png";